import { AvatarCell } from './avatar-cell/avatar-cell';
import { ButtonCell } from './button-cell/button-cell';
import { CheckboxCell } from './checkbox-cell/checkbox-cell';
import { DetailsCell } from './details-cell/details-cell';
import { DropdownCell } from './dropdown-cell/dropdown-cell';
import { EmptyCell } from './empty-cell/empty-cell';
import { HoverActionCell, } from './hover-action-cell/hover-action-cell';
import { LinkCell } from './link-cell/link-cell';
import { MenuCell } from './menu-cell/menu-cell';
import { RadioCell } from './radio-button-cell/radio-cell';
import { TagCell } from './tag-cell/tag-cell';
import { TextCell } from './text-cell/text-cell';
export var CellType;
(function (CellType) {
    CellType[CellType["link"] = 0] = "link";
    CellType[CellType["text"] = 1] = "text";
    CellType[CellType["avatar"] = 2] = "avatar";
    CellType[CellType["checkbox"] = 3] = "checkbox";
    CellType[CellType["radio"] = 4] = "radio";
    CellType[CellType["menu"] = 5] = "menu";
    CellType[CellType["hoverAction"] = 6] = "hoverAction";
    CellType[CellType["empty"] = 7] = "empty";
    CellType[CellType["details"] = 8] = "details";
    CellType[CellType["tag"] = 9] = "tag";
    CellType[CellType["button"] = 10] = "button";
    CellType[CellType["dropdown"] = 11] = "dropdown";
})(CellType || (CellType = {}));
export const CELL_TYPE_COMPONENTS = {
    link: LinkCell,
    checkbox: CheckboxCell,
    avatar: AvatarCell,
    text: TextCell,
    radio: RadioCell,
    menu: MenuCell,
    hoverAction: HoverActionCell,
    empty: EmptyCell,
    details: DetailsCell,
    tag: TagCell,
    button: ButtonCell,
    dropdown: DropdownCell,
};
//# sourceMappingURL=cell-type-service.js.map